import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { PensionArrangementType } from "../../../../../../../Wrap/Constants/Enums/Domain/PensionArrangementType";
import { PensionType } from "../../../../../../../Wrap/Constants/Enums/Domain/PensionType";
import { CustomerPensionProtectionModel } from "../../../../../../../Wrap/Models/Domains/Drawdown/CustomerPensionProtectionModel";
import { PensionBase } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/PensionBase";
import { SubAccountActionIndicators } from "../../../../../../../Wrap/Models/Models/Shared/SubAccountActionIndicators";
import { hasSinglePayments } from "../../../../../../Shared/IST/Components/Shared/Utils";

export const needSingleContribution = (config: SubAccountActionIndicators, model: PensionBase) => {
    if (
        config.PensionType != PensionType.None &&
        !hasSinglePayments(model) &&
        (model.PensionTransfers || []).every((e) => e?.PensionSource == PensionArrangementType.Crystallised)
    ) {
        return true;
    }
    return false;
};

export const needPostTransfer = (config: SubAccountActionIndicators, model: PensionBase) => {
    if (
        config.PensionType == PensionType.None &&
        config.IsIncomePaymentDetailsSelected == true &&
        (model.PensionTransfers || []).every((ele) => ele.PensionSource !== PensionArrangementType.Crystallised)
    ) {
        return true;
    }
    return false;
};

export const showIncome = (config: SubAccountActionIndicators, model: PensionBase, allowPclsPaymentOnly: boolean = false) => {
    if (!config.IsIncomePaymentDetailsSelected) {
        if (allowPclsPaymentOnly && config.PensionType != PensionType.None && model.DrawdownModel?.TaxFreeLumpSum?.Amount > 0) {
            return true;
        }
        return false;
    }

    if (config.PensionType == PensionType.None) {
        return true;
    }
    return !CommonHelper.isNullOrEmpty(model.DrawdownModel?.InstructionId);
};

export const isRestrictedToPensionContribution = (model: CustomerPensionProtectionModel) => {
    if (model?.Enhanced?.HasProtection && !model.Enhanced.HasBeenAppliedBefore15032023) {
        return true;
    }
    if (model?.Fixed?.some((x) => x.HasProtection && !x.HasBeenAppliedBefore15032023)) {
        return true;
    }
    return false;
};
